module.exports = __webpack_public_path__ + "img/second-day-5.9a6eedf0.png";